import(/* webpackMode: "eager" */ "/home/runner/work/galapagos/galapagos/apps/web/src/app/(signup)/page.tsx");
